import { createAction } from '@reduxjs/toolkit';

export const IGNORE_CALL_ACTION_TYPE = 'saga/ignoreCall';
export const ignoreCallAction = createAction(IGNORE_CALL_ACTION_TYPE);
